@if ((recentKeyWords && recentKeyWords.length) || articles?.length) {
  <div
    class="start-0 dropdown-menu col-md-12"
    [ngClass]="show ? 'show' : ''"
    >
    @if (recentKeyWords?.length) {
      <h5 class="px-3 pt-3 pb-1">{{ "RECENTLY_SEARCHED" | translate }}</h5>
    }
    @for (keyWord of recentKeyWords; track keyWord; let keywordIndex = $index) {
      @if (keywordIndex < 10) {
        <p
          class="dropdown-item clickable withOpacity m-0 p-2 ps-3"
          (click)="gotoSearch(keyWord)"
          >
          {{ keyWord }}
          <i class="material-icons clear" (click)="removeRecentItem(keyWord)"
            >clear</i
            >
          </p>
        }
      }
      @if (articles?.length) {
        <h5 class="px-3 pt-3 pb-1">{{ "RECENTLY_VIEWED" | translate }}:</h5>
      }
      @for (article of articles; track article) {
        <p
          class="dropdown-item clickable withOpacity m-0 p-2 ps-3 d-flex align-items-center"
          (click)="gotoArticle(article)"
          >
          <span>
            <img class="d-inline me-2" [src]="article?.thumbs[0]" style="" />
          </span>
          <span class="d-flex flex-column">
            <span>{{ article.description }}</span>
            @if (article.caption) {
              <small [innerHTML]="article.caption"></small>
            }
          </span>
        </p>
      }
    </div>
  }
